/*
  Quiz F&NT → Klaviyo (v9, sep 2026)
  - Escucha "fnt:quiz-completed" (lo dispara fnt-quiz.js; ese archivo no se toca).
  - Paso intermedio opcional entre la última pregunta y el resultado: panel con el
    formulario embebido de Klaviyo y "No, gracias, ver mi resultado" abajo.
    · No se muestra a visitantes ya identificados en Klaviyo, ni otra vez en la misma
      sesión a quien ya dio "No, gracias" o ya se suscribió.
    · Espera hasta 3 s a que Klaviyo dibuje el formulario (con "Armando tu rutina…" en pantalla);
      si no aparece, salta al resultado (nunca lo bloquea).
    · Deja en consola la razón de cada decisión: "[F&NT quiz] …".
  - La tarjeta existe desde que carga la página (fuera de la vista) porque Klaviyo solo
    dibuja formularios embebidos que encuentra al cargar; el JS la mueve al panel.
  - Guarda las respuestas en el perfil (propiedades de primer nivel, nombres fijos)
    y registra "Quiz Completed": si ya está identificado, al terminar; si no, al suscribirse.
  - Al suscribirse activa FNT10 en segundo plano (/discount/FNT10).
  Nombres de propiedades: NO renombrar (segmentos y flujos dependen de ellos).
*/
(function () {
  !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();

  var QUIZ_NAME = 'Encuentra tu suplemento ideal';
  var DISCOUNT = 'FNT10';
  var SESSION_KEY = 'fntQzGate';   // 'skipped' | 'done'

  var LABELS = {
    objetivo: { masa: 'Ganar masa muscular', fuerza: 'Fuerza y energía', recuperacion: 'Recuperación muscular', volumen: 'Subir de peso', peso: 'Reducir peso corporal' },
    estilo: { pesas: 'Pesas', bodybuilding: 'Bodybuilding', funcional: 'Funcional / híbrido', resistencia: 'Resistencia / cardio', ninguno: 'Aún no entreno' },
    dias: { '0': '0 días', '1-3': '1 a 3 días', '4-6': '4 a 6 días', '7': '7 días' },
    cafeina: { si: 'Con cafeína', no: 'Sin estimulantes', nose: 'No está seguro' },
    edad: { menor: 'Menos de 18', '18-24': '18 a 24', '25-34': '25 a 34', '35-49': '35 a 49', '50': '50 o más' }
  };

  var pending = null;
  var formId = null;
  var gate = null;

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }

  function label(group, value) {
    if (value == null) return '';
    return (LABELS[group] && LABELS[group][value]) || String(value);
  }

  function buildProps(detail) {
    var a = (detail && detail.answers) || {};
    return {
      'Objetivo': label('objetivo', a.objetivo),
      'Estilo de entrenamiento': label('estilo', a.estilo),
      'Días de entrenamiento': a.estilo === 'ninguno' ? '0 días' : label('dias', a.dias),
      'Cafeína': label('cafeina', a.cafeina),
      'Rango de edad': label('edad', a.edad),
      'Productos recomendados': (detail && detail.products) || [],
      'Combo recomendado': (detail && detail.combo) || '',
      'Quiz FNT completado': new Date().toISOString()
    };
  }

  function sendToKlaviyo(detail, email) {
    try {
      var props = buildProps(detail);
      var identity = {};
      for (var k in props) identity[k] = props[k];
      if (email) identity.email = email;
      var ev = { 'Quiz Name': QUIZ_NAME, 'Quiz ID': 'fnt-quiz' };
      for (var j in props) ev[j] = props[j];
      window.klaviyo.identify(identity).then(function () {
        window.klaviyo.track('Quiz Completed', ev);
      });
    } catch (e) {}
  }

  function applyDiscount() {
    try { fetch('/discount/' + DISCOUNT + '?redirect=/cart.js', { credentials: 'same-origin' }); } catch (e) {}
  }

  function els() {
    var root = document.querySelector('[data-fnt-qz]');
    if (!root) return null;
    return {
      root: root,
      top: root.querySelector('.fnt-qz__top'),
      loading: root.querySelector('[data-qz-loading]'),
      result: root.querySelector('[data-qz-result]'),
      hero: root.querySelector('[data-qz-hero]'),
      box: document.querySelector('[data-qz-capture]')
    };
  }

  function formRendered(box) {
    var slot = box && box.querySelector('[class*="klaviyo-form-"]');
    return !!(slot && slot.innerHTML.trim().length);
  }

  function log(msg) {
    try { console.info('[F&NT quiz] ' + msg); } catch (e) {}
  }

  function whenRendered(box, ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function check() {
        if (formRendered(box)) return resolve(true);
        if (Date.now() - t0 > ms) return resolve(false);
        setTimeout(check, 150);
      })();
    });
  }

  function isKnown(ms) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(v) { if (!done) { done = true; resolve(!!v); } }
      setTimeout(function () { finish(false); }, ms);
      try { window.klaviyo.isIdentified().then(finish, function () { finish(false); }); } catch (err) { finish(false); }
    });
  }

  function buildGate(e) {
    if (gate) return gate;
    gate = document.createElement('div');
    gate.className = 'fnt-qz__gate';
    gate.setAttribute('data-qz-gate', '');
    gate.hidden = true;
    gate.innerHTML =
      '<div class="fnt-qz__panel fnt-qz__gate-panel">' +
        '<div class="fnt-qz__bar"><i style="width:100%"></i></div>' +
        '<div class="fnt-qz__gate-form"></div>' +
        '<button type="button" class="fnt-qz__skip" data-qz-skip>No, gracias, ver mi resultado</button>' +
      '</div>';
    gate.querySelector('.fnt-qz__gate-form').appendChild(e.box);
    e.box.classList.remove('fnt-qz__capture--parked');
    e.top.insertBefore(gate, e.result);
    gate.querySelector('[data-qz-skip]').addEventListener('click', function () {
      if (ss(SESSION_KEY) !== 'done') ss(SESSION_KEY, 'skipped');
      reveal();
    });
    return gate;
  }

  function reveal() {
    var e = els();
    if (!e) return;
    if (gate) gate.hidden = true;
    if (e.loading) e.loading.hidden = true;
    e.result.hidden = false;
    if (e.hero) e.hero.hidden = false;
    e.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function openGate(e) {
    buildGate(e);
    var skip = gate.querySelector('[data-qz-skip]');
    skip.className = 'fnt-qz__skip';
    skip.textContent = 'No, gracias, ver mi resultado';
    if (e.loading) e.loading.hidden = true;
    gate.hidden = false;
    e.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cfg = document.querySelector('[data-fnt-qz-klaviyo]');
    if (cfg) formId = cfg.getAttribute('data-form-id');
  });

  document.addEventListener('fnt:quiz-completed', function (ev) {
    var detail = ev.detail || {};
    pending = detail;
    var e = els();
    if (!e || !e.result) return;

    // fnt-quiz.js ya mostró el resultado; lo ocultamos en el mismo instante (sin parpadeo)
    // y dejamos "Armando tu rutina…" mientras se decide.
    e.result.hidden = true;
    if (e.hero) e.hero.hidden = true;
    if (e.loading) e.loading.hidden = false;

    var flag = ss(SESSION_KEY);
    isKnown(1500).then(function (known) {
      if (known) {
        log('visitante identificado en Klaviyo: sin paso intermedio, respuestas guardadas');
        sendToKlaviyo(detail);
        pending = null;
        reveal();
        return;
      }
      if (flag === 'skipped' || flag === 'done') {
        log('ya vio el paso en esta sesión (' + flag + '): directo al resultado');
        reveal();
        return;
      }
      if (!e.box) {
        log('no existe la tarjeta del formulario: directo al resultado');
        reveal();
        return;
      }
      whenRendered(e.box, 3000).then(function (ok) {
        if (!ok) {
          log('Klaviyo no dibujó el formulario a tiempo: directo al resultado');
          reveal();
          return;
        }
        log('paso intermedio mostrado');
        openGate(e);
      });
    });
  });

  window.addEventListener('klaviyoForms', function (ev) {
    var d = ev.detail || {};
    if (d.type !== 'submit' || !formId || d.formId !== formId) return;
    var email = d.metaData && (d.metaData.$email || d.metaData.email);
    if (pending) {
      sendToKlaviyo(pending, email);
      pending = null;
    }
    applyDiscount();
    ss(SESSION_KEY, 'done');
    if (gate) {
      var skip = gate.querySelector('[data-qz-skip]');
      skip.className = 'fnt-btn fnt-btn--primary fnt-qz__skip fnt-qz__skip--go';
      skip.textContent = 'Ver mi rutina';
    }
  });
})();
